interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'onChange'> {
  onChange: (value: string) => void
}

const PositiveInput: React.FC<Props> = ({ onChange, ...props }) => {
  const handleInputChange = (e) =>
    onChange(`${e.target.value}`?.replace(new RegExp('-', 'g'), ''))
  const handleInputPaste = (e) => props.value && e.preventDefault()
  const handleKeyPress = (e) => e.key === '-' && e.preventDefault()

  return (
    <input
      inputMode="decimal"
      min={0}
      onChange={handleInputChange}
      onKeyPress={handleKeyPress}
      onPaste={handleInputPaste}
      type="number"
      {...props}
    />
  )
}

export default PositiveInput
